import { render } from "./CaseResponsibility.vue?vue&type=template&id=ec99c57c&scoped=true&ts=true"
import script from "./CaseResponsibility.vue?vue&type=script&lang=ts"
export * from "./CaseResponsibility.vue?vue&type=script&lang=ts"

import "./CaseResponsibility.vue?vue&type=style&index=0&id=ec99c57c&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec99c57c"]])

export default __exports__